import type { Margin, Owner, OwnerDetails } from "~/v2/api/rest/account";
import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";

export const useIsEligibleForFPSL = ({
  product,
  margin,
  owner,
  ownerDetails,
  isLegalEntity,
  isLegalEntityLoading,
}: {
  product: string | undefined;
  margin: Margin | null | undefined;
  owner: Owner | undefined;
  ownerDetails: OwnerDetails | undefined;
  isLegalEntity: boolean | undefined;
  isLegalEntityLoading: boolean | undefined;
}) => {
  const bypassCountryCheck = useFeatureEnabled(
    FeatureFlags.FPSL_COUNTRY_CHECK_BYPASS,
  );

  return (
    !!margin &&
    !!owner &&
    !!ownerDetails &&
    product === "live" &&
    !isLegalEntityLoading &&
    (bypassCountryCheck || owner.country_of_tax_residence === "USA") &&
    (isLegalEntity
      ? bypassCountryCheck || owner.country_of_incorporation === "USA"
      : Number(margin.cash) > 2500 ||
        Number(ownerDetails.annual_income_min) >= 20000 ||
        Number(ownerDetails.liquid_net_worth_min) >= 20000 ||
        (ownerDetails.investment_experience_with_stocks &&
          ownerDetails.investment_experience_with_stocks !== "none") ||
        (ownerDetails.investment_experience_with_options &&
          ownerDetails.investment_experience_with_options !== "none"))
  );
};
